// c-popup.js
export const openBtns = (modalId, openBtnSelector, closeBtnId) => {
    // Standardize IDs (remove # if user included them)
    const cleanModalId = modalId.replace('#', '');
    const cleanCloseId = closeBtnId.replace('#', '');

    const modal = document.getElementById(cleanModalId);
    const openBtnsList = document.querySelectorAll(openBtnSelector); 
    const closeBtn = document.getElementById(cleanCloseId);

    // DEBUGGING - View this in your browser console (F12)
    console.log("Popup Init:", {
        modalElement: modal,
        triggersFound: openBtnsList.length,
        closeElement: closeBtn
    });

    if (!modal || openBtnsList.length === 0 || !closeBtn) return;

    const openPopup = (e) => {
        if(e) e.preventDefault();
        modal.classList.add('show');
        document.body.style.overflow = 'hidden';
        console.log("Popup Opened");
    };

    const closePopup = () => {
        modal.classList.remove('show');
        document.body.style.overflow = '';
        console.log("Popup Closed");
    };

    // Listeners
    openBtnsList.forEach(btn => btn.addEventListener('click', openPopup));
    closeBtn.addEventListener('click', closePopup);

    // Close on clicking the dark background area
    modal.addEventListener('click', (event) => {
        if (event.target === modal) closePopup();
    });

    // Close on Escape key
    window.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closePopup();
    });
};